import {notificationStatus, notificationType, REJECTION_REASONS} from '../../utils/constant';
import {INVITATIONS, INVITATIONS_NOT_DEPOSITOR, NOT_INFORMATIVE_NOTIFICATIONS, NOT_INFORMATIVE_NOTIFICATIONS_NOT_DEPOSITOR} from '../../components/notification/NotificationData';

let notificationsInDb = [
  {
    notificationId: 1,
    organisationId: 1,
    type: notificationType.USER_LINKED,
    creationDate: '2019-03-27T10:25:30.00Z',
    status: notificationStatus.NEW,
    targetId: '3370',
    user: {
      userId: '3370',
      firstName: 'John',
      lastName: 'Doe',
      organisationName: 'ALG'
    },
    viewed: false
  },
  {
    notificationId: 2,
    organisationId: 1,
    creationDate: '2018-11-25T10:15:30.00Z',
    status: notificationStatus.NEW,
    type: notificationType.DOCUMENT_REJECTED,
    document: {
      documentId: 'f81d4fae-7dec-11d0-a765-00a0c91e6bf8',
      documentName: 'Gewerbeanmeldung',
      certifyingThirdParty: 'CDS LYON',
      additionalDesignation: 'ADDITIONAL DESIGNATION',
      rejectionReason: 'This a long rejection reason ... Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur'
    },
    viewed: false
  },
  {
    notificationId: 3,
    organisationId: 1,
    type: notificationType.DOCUMENT_EXPIRED,
    creationDate: '2018-11-26T08:15:30.00Z',
    status: notificationStatus.NEW,
    document: {
      documentId: 'f81d4fae-7dec-11d0-a765-00a0c91e6bf7',
      documentName: 'Dewerjeanmelkung',
      certifyingThirdParty: 'CDS LYON',
      additionalDesignation: 'ADDITIONAL DESIGNATION',
      rejectionReason: null
    },
    viewed: false
  },
  {
    notificationId: 4,
    organisationId: 1,
    type: notificationType.DOCUMENT_AWAITING_SIGNATURE,
    creationDate: '2018-11-26T08:15:30.00Z',
    status: notificationStatus.NEW,
    document: {
      documentId: 'f81d4fae-7dec-11d0-a765-00a0c91e6bf7',
      certifyingThirdParty: 'CDS LYON',
      documentName: 'Liste des salariés étrangers soumis à autorisation de travail',
      rejectionReason: null
    },
    viewed: false
  },
  {
    notificationId: 5,
    organisationId: 1,
    type: notificationType.PROJECT_NOT_AUTOMATICALLY_ACCEPTED,
    creationDate: '2018-11-25T08:15:30.00Z',
    status: notificationStatus.NEW,
    intervention: {
      projectId: 1,
      interventionId: 28,
      projectName: 'AFB',
      invitingOrganisationName: 'ALG'
    },
    viewed: false
  },
  {
    notificationId: 6,
    organisationId: 1,
    type: notificationType.RELATIONSHIP_NOT_AUTOMATICALLY_ACCEPTED,
    creationDate: '2018-11-25T08:15:30.00Z',
    status: notificationStatus.NEW,
    relationship: {
      relationshipId: 1,
      invitingOrganisationName: 'INVITING_CLIENT'
    },
    viewed: false
  },
  {
    notificationId: 7,
    organisationId: 1,
    type: notificationType.RELATIONSHIP_NOT_AUTOMATICALLY_ACCEPTED,
    creationDate: '2018-11-25T08:15:30.00Z',
    status: notificationStatus.NEW,
    relationship: {
      relationshipId: 1,
      invitingOrganisationName: 'INVITING_SUB_CONTRACTOR',
      organisationSourceId: 10
    },
    viewed: false
  },
  {
    notificationId: 8,
    organisationId: 1,
    type: notificationType.DEPOSITOR_SERVICE_ACTIVATED,
    creationDate: '2018-11-25T08:15:30.00Z',
    status: notificationStatus.NEW,
    viewed: false
  },
  {
    notificationId: 9,
    organisationId: 1,
    type: notificationType.RELATIONSHIP_AUTOMATICALLY_ACCEPTED,
    creationDate: '2018-11-25T08:15:30.00Z',
    status: notificationStatus.NEW,
    relationship: {
      relationshipId: 1,
      invitingOrganisationName: 'INVITING_CLIENT',
      organisationSourceId: 10
    },
    viewed: false
  },
  {
    notificationId: 10,
    organisationId: 1,
    type: notificationType.PROJECT_AUTOMATICALLY_ACCEPTED,
    creationDate: '2018-11-25T08:15:30.00Z',
    status: notificationStatus.NEW,
    intervention: {
      projectId: 1,
      projectName: 'Incity'
    },
    viewed: false
  },
  {
    notificationId: 11,
    organisationId: 1,
    type: 'PROJECT_REJECTED',
    creationDate: '2018-11-25T08:15:30.00Z',
    status: notificationStatus.NEW,
    intervention: {
      projectId: 1,
      projectName: 'Incity',
      rejectionReason: REJECTION_REASONS.UNKNOWN_ORGANISATION,
      invitedOrganisationName: 'INVITED ORG NAME'
    },
    viewed: false
  },
  {
    notificationId: 12,
    organisationId: 1,
    type: 'PROJECT_ORGANISATION_ENDED',
    creationDate: '2018-11-25T08:15:30.00Z',
    status: notificationStatus.NEW,
    intervention: {
      projectId: 1,
      projectName: 'Incity',
      invitedOrganisationName: 'INVITED ORG NAME'
    },
    viewed: false
  },
  {
    notificationId: 13,
    organisationId: 1,
    type: 'RELATIONSHIP_REJECTED',
    creationDate: '2018-11-25T08:15:30.00Z',
    status: notificationStatus.NEW,
    relationship: {
      rejectionReason: REJECTION_REASONS.UNKNOWN_ORGANISATION,
      invitedOrganisationName: 'INVITED ORG NAME',
      organisationSourceId: 1
    },
    viewed: false
  },
  {
    notificationId: 14,
    organisationId: 1,
    type: notificationType.DOCUMENT_ALMOST_EXPIRED,
    creationDate: '2018-11-25T10:15:30.00Z',
    status: notificationStatus.NEW,
    document: {
      documentId: 'f81d4fae-7dec-11d0-a765-00a0c91e6bf8',
      documentName: 'Gewerbeanmeldung',
      certifyingThirdParty: 'CDS LYON',
      rejectionReason: 'REJECTION REASON',
      expirationDate: '2018-11-29T10:15:30.00Z'
    },
    viewed: false
  },
  {
    notificationId: 15,
    organisationId: 1,
    type: notificationType.DOCUMENT_VALIDATED,
    creationDate: '2018-11-26T08:15:30.00Z',
    status: notificationStatus.NEW,
    document: {
      documentId: 'f81d4fae-7dec-11d0-a765-00a0c91e6bf7',
      documentName: 'Dewerjeanmelkung',
      expirationDate: '2018-12-26T08:15:30.00Z'
    },
    viewed: false
  },
  {
    notificationId: 16,
    organisationId: 1,
    type: notificationType.PROJECT_CLOSED,
    creationDate: '2018-11-26T08:15:30.00Z',
    status: notificationStatus.NEW,
    targetId: '100',
    project: {
      projectName: 'Incity',
      organisationOwnerName: 'ALG'
    },
    viewed: false
  },
  {
    notificationId: 17,
    organisationId: 1,
    type: notificationType.DOCUMENT_REQUALIFIED,
    creationDate: '2019-02-12T10:25:30.00Z',
    status: notificationStatus.NEW,
    document: {
      documentId: 'f81d4fae-7dec-11d0-a765-00a0c91e6bf7',
      documentName: 'SOKA Bau / ULAK',
      previousDocumentName: 'SOKA Bau Negativbescheinigung'
    },
    viewed: false
  },
  {
    notificationId: 18,
    organisationId: 1,
    type: notificationType.USER_ROLE_UPDATED,
    creationDate: '2019-02-12T10:25:30.00Z',
    status: notificationStatus.NEW,
    targetId: '3369',
    user: {
      userId: '3369',
      firstName: 'John',
      lastName: 'Doe',
      organisationName: 'ALG-GC',
      role: 'DEFAULT'
    },
    viewed: false
  },
  {
    notificationId: 19,
    organisationId: 1,
    type: notificationType.DOCUMENT_MANDATE_DISABLED,
    creationDate: '2019-02-12T10:25:30.00Z',
    status: notificationStatus.NEW,
    document: {
      documentId: 'f81d4fae-7dec-11d0-a765-00a0c91e6bf7',
      documentName: 'Attestation fiscale étranger',
      collectionMandateDisabledReason: 'ce document n\'est pas collectable'
    },
    viewed: false
  },
  {
    notificationId: 20,
    organisationId: 1,
    type: notificationType.USER_PERMISSIONS_UPDATED,
    creationDate: '2019-02-12T10:25:30.00Z',
    status: notificationStatus.NEW,
    targetId: '3369',
    user: {
      userId: '3369',
      firstName: 'John',
      lastName: 'Doe',
      organisationName: 'ALG-GC',
      permission: 'SIGN',
      action: 'ADDITION'
    },
    viewed: false
  },
  {
    notificationId: 21,
    organisationId: 1,
    type: notificationType.USER_PENDING,
    creationDate: '2019-02-12T10:25:30.00Z',
    status: notificationStatus.NEW,
    targetId: '3369',
    user: {
      userId: '3369',
      email: 'phoebe.buffay@yopmail.com',
      firstName: 'Phoebe',
      lastName: 'Buffay'
    },
    viewed: false
  },
  {
    notificationId: 22,
    organisationId: 1,
    type: notificationType.REQUIRED_DOCUMENTS_IN_PROJECT_DOSSIER_OVERVIEW_UPDATED,
    creationDate: '2019-07-23T11:36:41.00Z',
    status: notificationStatus.NEW,
    targetId: '42',
    project: {
      projectName: 'Tour Eiffel'
    },
    viewed: false
  },
  {
    notificationId: 23,
    organisationId: 1,
    type: notificationType.DOCUMENT_AT_DATE,
    creationDate: '2020-12-08T09:00:15.00Z',
    status: notificationStatus.NEW,
    documentAtDate: {
      documentName: 'Attestation Décennale Standard',
      year: 2016,
      projects: [
        {
          id: 23,
          name: 'ABC',
          openingDate: '2016-01-01T00:00:00Z'
        },
        {
          id: 45,
          name: 'Building',
          openingDate: '2016-05-05T00:00:00Z'
        },
        {
          id: 59,
          name: 'Here I am',
          openingDate: '2016-10-10T00:00:00Z'
        }
      ]
    },
    viewed: false
  }
];

export default class FakeNotificationService {
  getNewInformationNotifications(organisation) {
    const types = organisation.depositor ?
      NOT_INFORMATIVE_NOTIFICATIONS :
      NOT_INFORMATIVE_NOTIFICATIONS_NOT_DEPOSITOR;
    const notifications = notificationsInDb.filter(notification => notification.status === notificationStatus.NEW &&
      !types.includes(notification.type));
    const result = {
      notifications,
      numberOfNewNotifications: notifications.filter(notification => !notification.viewed).length,
      totalCount: notifications.length
    };
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(result);
      }, 0);
    });
  }

  getNewActionsNotifications(organisation) {
    const types = organisation.depositor ?
      INVITATIONS :
      INVITATIONS_NOT_DEPOSITOR;
    const notifications = notificationsInDb.filter(notification => notification.status === notificationStatus.NEW &&
      types.includes(notification.type));
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(notifications);
      }, 0);
    });
  }

  dismiss(notificationId) {
    notificationsInDb = notificationsInDb.filter(notification => notification.notificationId !== notificationId);
    return Promise.resolve();
  }

  updateLastSeenNotifications() {
    return Promise.resolve();
  }

  updateNotificationByUploadingFile() {
    // method parameters would be {notificationId, file}
    return new Promise(resolve => {
      setTimeout(() => resolve(), 0);
    });
  }
}
